import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class PhotoId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): PhotoId {
    return new PhotoId(value);
  }
}
